import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Select, TextField} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {addBRBusinessShare} from "../../../actions";
import {bbDictionaryOfBreachRiskLevels} from "../../../util/bbHelpers";
import {CircularProgress, MenuItem, Tooltip} from "@mui/material";
// import {xmlString} from "../constants/customer_industries_xml";
// import {KeyboardDatePicker} from "@material-ui/pickers"
// import {bbDangerousDateToBBApiDate} from "../util/bbHelpers";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const {targetEntityId} = props;

    // console.log("Displaying Sharing invitation form. Entity ID is", targetEntityId)

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustCreateNewShare, } = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {loadingAddBRBusinessShare, loadingAddBRBusinessShareError, } = useSelector(({breachrisk}) => breachrisk);

    const {customerInView} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();

    const [email, setEmail] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [comments, setComments] = useState(null);
    const [entityId, setEntityId] = useState(targetEntityId);
    const [dataLevel, setDataLevel] = useState(2);

    const accessLevelArray = bbDictionaryOfBreachRiskLevels
    && Object.values(bbDictionaryOfBreachRiskLevels)
        ? Object.values(bbDictionaryOfBreachRiskLevels) : [];

    const clearForm = () => {
        setCompanyName("");
        setEmail("");
        setFirstName("");
        setLastName("");
        setComments("");
        setDataLevel(2);
        document.getElementById('NewBRShareInvitationForm').reset();
    }


  useEffect(() => {
    if(didJustCreateNewShare) {
        clearForm();
    }
    // setLocalLoading(false);
  }, [dispatch, didJustCreateNewShare]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        dispatch(addBRBusinessShare({
            "email": email,
            "companyName": companyName,
            "firstName": firstName,
            "lastName": lastName,
            "comments": comments,
            "entityId": entityId,
            customerId: customerInView,
            dataLevel: dataLevel,
        }));

    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">
            {/*<h2>Create New Client</h2>*/}
            {/*<p>This will create a new client (customer) CIRT Breachboard.</p>*/}

            {loadingAddBRBusinessShare[customerInView] || loadingAddBRBusinessShareError[customerInView]
                ?<div className={"text-center m-5 p-5"}>
                <CircularProgress/>
                </div>
                :<form id={"NewBRShareInvitationForm"} className={classes.root}>
                <h3>Company</h3>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.company_name"/>}
                    // fullWidth
                    id="company_name"
                    name="companyName"
                    required
                    error={!!errors.companyName}
                    onChange={(event) => setCompanyName(event.target.value)}
                    defaultValue={companyName}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.companyName?.message}
                />
                <br/>
                <h3>Point of Contact</h3>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.first_name"/>}
                    // fullWidth
                    id="first_name"
                    name="firstName"
                    required
                    error={!!errors.firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                    defaultValue={firstName}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.firstName?.message}
                />
                <br/>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.last_name"/>}
                    // fullWidth
                    id="lastName"
                    name="lastName"
                    required
                    error={!!errors.lastName}
                    onChange={(event) => setLastName(event.target.value)}
                    defaultValue={lastName}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.lastName?.message}
                />
                <br/>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.email"/>}
                    // fullWidth
                    id="email"
                    name="email"
                    required
                    error={!!errors.email}
                    onChange={(event) => setEmail(event.target.value)}
                    defaultValue={email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                        pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

                    })}
                    helperText={errors.email?.type === "pattern" && "Please enter a valid email address." || errors.email?.message}
                />

                <br/>
                <Select
                    labelId="appModule.newBRBusinessShare.dataLevel"
                    id="dataLevel"
                    name="dataLevel"
                    value={dataLevel}
                    onChange={(event) => setDataLevel(event.target.value)}
                    // displayEmpty
                    className={"mt-1 my-sm-3"}
                >
                    {accessLevelArray &&
                        accessLevelArray.map((option, i)=>{
                                return  <MenuItem key={i} value={option.value} className={"d-block p-1"}>
                                    <Tooltip title={option.description}>
                                        <span>{option.icon}&nbsp;{option.label}</span>
                                    </Tooltip>
                                </MenuItem>
                            }
                        )
                    }
                </Select>
                <div style={{width: "100%"}} className="m-0 p-0 d-flex align-items-center justify-content-between row">
                    {(dataLevel === 3 || dataLevel === 4)
                        &&
                        <p className={"m-0 p-0 text-red"}><small>
                            ** Ensure this is the appropriate access level to give to this company.
                        </small>
                        </p>}
                </div>
                <div style={{width: "100%"}} className="m-0 p-0 d-flex align-items-center justify-content-between row">
                    <div className={"col col-12 m-0 p-0"}>
                        <p className={` m-0 p-0`}>
                            <small>
                                {bbDictionaryOfBreachRiskLevels[dataLevel].description}
                            </small>
                        </p>
                    </div>
                </div>

                <h3>Comments (optional)</h3>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.comments"/>}
                    fullWidth
                    id="comments"
                    name="comments"
                    // required
                    error={!!errors.comments}
                    onChange={(event) => setComments(event.target.value)}
                    defaultValue={comments}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    // inputRef={register({
                    //     required: "This field is required." ,
                    //     // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    // })}
                    helperText={ errors.comments?.message}
                />
                <br/>
                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.companyName || !!errors.firstName || !!errors.lastName || !!errors.email}
                                variant="contained" color="primary">
                            <IntlMessages id="form.submit"/>
                        </Button>
                    </div>

            </form>}

        </div>
    );

}

export default Form